<template>
   <div>
     <v-collapse-wrapper :active="true">
       <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
            v-collapse-toggle>
         <h3>{{$t('form.lot.bids-history')}}</h3>
       </div>

       <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
         <div class="a-ui-tab u-margin-b-24">
           <div class="a-ui-tab__block">
             <div class="a-ui-tab__content-block">
               <p class="a-label" v-if="history.length == 0">{{$t('form.lot.bids-history-table.there-are-not-bids')}}</p>
               <section v-maximizable v-else>
                 <div class="table-tab">
                   <div class="table-tab__container" style="overflow-x: auto">
                     <table class="table-tab__block table " style="width: 100%">
                       <thead class="table-tab__thead table-tab__border-bottom">
                         <tr class="">
                           <th>{{$t('form.lot.bids-history-table.time')}}</th>
                           <th>{{$t('form.lot.bids-history-table.bid-number')}}</th>
                           <th>{{$t('form.lot.bids-history-table.organization')}}</th>
                           <th>{{$t('form.lot.bids-history-table.retend')}}</th>
                           <th>{{$t('form.lot.bids-history-table.present-price')}}</th>
                           <th>{{$t('form.lot.bids-history-table.state')}}</th>
                         </tr>
                       </thead>

                       <tbody>
                        <tr v-for="record of activePage" :key="`${record.num}-${record.time}`">
                          <th class="table-tab__th table-tab__color u-hr-underline">
                            <router-link class="table-tab__color u-text-underline"
                                         :to="{
                                           name: 'purchases-public-lot-alien-bid-history',
                                           params: {
                                             lotId: lot.id,
                                             requestId: record.requestId,
                                             historyId: record.bidId,
                                             bidId: record.bidId,
                                             tab: 'bid'
                                           }
                                         }">
                              <date-time tag="span" :value="record.time"></date-time>
                            </router-link>
                          </th>
                          <th>{{record.num}}</th>
                          <th>{{record.organization}}</th>
                          <th>{{record.retend == 0 ? '' : $tc('form.lot.bids-history-table.retend-number', record.retend)}}</th>
                          <th>{{record.presentPrice | price}}</th>
                          <th>{{$t(record.state.label)}}</th>
                        </tr>
                       </tbody>
                     </table>
                   </div>
                 </div>
               </section>
             </div>
           </div>
         </div>
         <pagination :count="history.length" :page="page" :pageSize="pageSize" :sizes="[5, 10, 20, 50]" @change="onPageChange"></pagination>
       </div>
     </v-collapse-wrapper>
   </div>
</template>

<script>
  import _ from 'lodash'
  import Pagination from '@/components/pagination/Pagination'

  export default {
    props: {
      lot: Object
    },

    components: {
      Pagination
    },

    data: () => ({
      page: 1,
      pageSize: 5
    }),

    computed: {
      history() {
        return _.orderBy(this.lot.bidsHistory, 'time', 'desc');
      },

      activePage() {
        const firstIndex = (this.page - 1) * this.pageSize;
        const lastIndex = (this.page - 1) * this.pageSize + this.pageSize;

        return this.history.slice(firstIndex, lastIndex);
      }
    },

    methods: {
      onPageChange(event) {
        this.page = event.page;
        this.pageSize = event.pageSize;
      }
    }
  }
</script>

<style scoped>

</style>
